class LancamentoOperations {
  constructor(modal, attrs) {
    this.modal = modal
    this.hasVoltarAction = attrs.hasOwnProperty('onVoltar')
  }

  openSyncModal() {
    this.modal.open({
      component: 'auditoriaIntegradaSyncModal',
      resolve: {
        empresaId: this.empresaId,
        contratoId: this.contratoId
      }
    })
  }
}

angular.module('eficienciaFiscalModule').component('lancamentoOperations', {
  controller: ['$uibModal', '$attrs', LancamentoOperations],
  bindings: {
    onChange: '&',
    onVoltar: '&',
    empresaId: '<',
    tabName: '<',
    contratoId: '<'
  },
  template: `
    <operations-toolbar>
      <left ng-if="$ctrl.hasVoltarAction">
        <button class="btn btn-default" ng-click="$ctrl.onVoltar()">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>
      </left>

      <right>
        <button type="button" ng-if="$ctrl.tabName === 'extratos'" class="btn btn-default" ng-click="$ctrl.openSyncModal()">
          <i class="fa fa-refresh"></i> Sincronização manual
        </button>

        <a href="https://det.sefin.ro.gov.br/" target="_blank" class="btn btn-default" style="margin: 5px">
          <i class="fa fa-link"></i> Portal do Contribuinte
        </a>
      </right>
    </operations-toolbar>
  `
})
